"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUniqueIdGenerator = void 0;
const faker_1 = __importDefault(require("@faker-js/faker"));
faker_1.default.seed(718);
const createUniqueIdGenerator = () => {
    const offset = faker_1.default.datatype.number({ max: 5, min: 1 });
    let currentId = faker_1.default.datatype.number({ min: 1 });
    return () => (currentId += offset);
};
exports.createUniqueIdGenerator = createUniqueIdGenerator;
